import { Container, Input } from 'components/atoms';
import { t } from 'i18next';
import { PiBank, PiHouseLine, PiWallet } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { CUSTOMER_TYPE } from 'services/labels/types';
import { useGetCountries } from 'services/enums';
import { AddressForm } from 'components/molecules';
import ViewHint from 'components/molecules/hint/ViewHint';

const LabelBilingAddres = () => {
  const { data: label } = useGetLabel(false);
  const countries = useGetCountries();

  const getCountryLabel = (code?: string) => {
    if (!code) return '';

    const country = countries.data?.find((c) => c.codeAlfa2 === code);

    return country ? t(`countries.${country.codeAlfa2}`) : code;
  };

  return (
    <>
      <div />
      <ViewHint hintId="label-billing-address" />
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`address.countryAlfa2`}
          label={t('input.label.country')}
          value={getCountryLabel(label?.addressCountry)}
          borderless
          fullWidth
          readOnly
        />
        <Input.Text
          name={`address.zipCode`}
          label={t('input.label.zipCode')}
          borderless
          fullWidth
          value={label?.addressZipCode}
          readOnly
        />
      </Input.ComplexWrapper>
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`address.city`}
          label={t('input.label.city')}
          borderless
          fullWidth
          value={label?.addressCity}
          readOnly
        />
        <Input.Text
          name={`address.street`}
          label={t('input.label.street')}
          borderless
          fullWidth
          value={label?.addressStreet}
          readOnly
        />
      </Input.ComplexWrapper>
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`address.houseNumber`}
          label={t('input.label.houseNumber')}
          borderless
          fullWidth
          value={label?.addressHouseNumber}
          readOnly
        />
        <Input.Text
          name={`address.flatNumber`}
          label={t('input.label.flatNumber')}
          borderless
          fullWidth
          value={label?.addressFlatNumber}
          readOnly
        />
      </Input.ComplexWrapper>
    </>
  );
};

export default LabelBilingAddres;
